/* ==============================
商品ページ-ラインナップ
============================== */
const mql = window.matchMedia('(max-width: 767px)');
let lineup_slider, lineup_slider_bool;
const product_slider = document.querySelectorAll('.product-slider');

const createSwiper = () => {
  product_slider.forEach(slider => {
    lineup_slider = new Swiper(slider, {
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        type: 'fraction'
      },
      slidesPerView: 2.5,
      spaceBetween: 10,
      slidesPerGroup: 2,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },
    });
  })
}

const changewindow = (e) => {
  if (e.matches && !lineup_slider_bool) {
    createSwiper();
    lineup_slider_bool = true;
    product_slider.forEach(slider1 => {
      if (slider1.swiper.slides.length < 3) {
        if (slider1.querySelector('.swiper-pagination') != null){
          slider1.querySelector('.swiper-pagination').style.display = 'none';
          slider1.querySelector('.swiper-button-next').style.display = 'none';
          slider1.querySelector('.swiper-button-prev').style.display = 'none';
        }
      } else {
        slider1.classList.add('tororo-lineup__group--padding-reset');
      }
    });
  } else if (lineup_slider_bool) {
    product_slider.forEach(slider => {
      slider.swiper.destroy();
    });
    lineup_slider_bool = false;
  }
}

mql.addEventListener('change', changewindow);
changewindow(mql);